import React from "react";
import NewsTiles from "components/NewsTiles";

const InTheNewsComponent = ({ data }) => {
  const newsTilesListData = data?.map(
    ({ frontmatter: { image, linkUrl, newsStartDate, title } = {} }) => ({
      label: title,
      date: newsStartDate,
      image,
      linkUrl,
    })
  );

  return (
    <NewsTiles
      NewsTilesList={newsTilesListData}
      background="#fff"
      fontColor="#000"
    />
  );
};

export default InTheNewsComponent;
